import { api } from "./client";
import type { Page } from "./hits";

export interface HotlistEntry {
  id: number;
  tipoLista: string;
  vin: string | null;
  placa: string | null;
  motor: string | null;
  marca: string | null;
  submarca: string | null;
  modelo: string | null;
  version: string | null;
  anio: number | null;
  tipo: string | null;
  estado: string | null;
  municipio: string | null;
  fechaReporte: string | null;
  observaciones: string | null;
  source: string;
  activo: boolean;
  createdAt: string;
  updatedAt: string;
}

export async function listHotlist(params: {
  q?: string;
  tipoLista?: string;
  page?: number;
  size?: number;
}): Promise<Page<HotlistEntry>> {
  const res = await api.get<Page<HotlistEntry>>("/hotlist", { params });
  return res.data;
}

export async function createHotlist(body: Partial<HotlistEntry>): Promise<HotlistEntry> {
  const res = await api.post<HotlistEntry>("/hotlist", body);
  return res.data;
}

export async function deleteHotlist(id: number): Promise<void> {
  await api.delete(`/hotlist/${id}`);
}

export async function importHotlist(
  formato: "csv" | "xlsx",
  file: File
): Promise<{ insertados: number; actualizados: number; omitidos: number; errores: number; totalFilas: number }> {
  const data = new FormData();
  data.append("formato", formato);
  data.append("file", file);
  const res = await api.post("/hotlist/import", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
